export default __webpack_public_path__ + "content/license_agreement.pdf";